export default __webpack_public_path__ + "static/media/product.33e96933.svg";